export default __webpack_public_path__ + "static/media/prospect.6e99f76b.svg";